import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import { IntegrationApiFeaturesCongestionReportsContractsDataUnderlyingAsset as UnderlyingAssets } from '@alliander-fe/api';
import { FilteredCongestionReportsParagraphProps } from 'components/CongestionReportsParagraph';
import { enrichObjectData } from 'src/utils/enrichObjectData';
import { getAssetDataByAssetType } from './getAssetDataByAssetType';
import { AssetType } from './getAssetData';

export type FieldProps = {
  reportDates?: string;
  researchApplicableText: string | undefined | null;
  congestionManagementText: string | undefined | null;
  mainAsset: UnderlyingAssets | undefined;
} & Omit<
  FilteredCongestionReportsParagraphProps,
  | 'congestionReport'
  | 'isLoading'
  | 'isError'
  | 'congestionManagementApplicable'
  | 'congestionManagementNotApplicable'
  | 'congestionManagementNotYetApplicable'
  | 'researchApplicableText'
  | 'supplyResearchCongestionManagementText'
  | 'consumeResearchCongestionManagementText'
>;

type AssetData = {
  attachmentText?: string;
  attachmentTitle?: string;
  expressInterestButton?: LinkFieldValue;
  expressInterestText?: string;
  howAndWhenText?: string;
  introText?: string;
  introTextPartTwo?: string;
  maxCapacityText?: string;
  notableAspectsText?: string;
  capacityTextFirstPart?: string;
  capacityTextSecondPart?: string;
  availableCapacityHigherThanRequiredCapacityText?: string;
  downloadReportButtonLabel?: string;
  researchApplicableText?: string;
  consumeResearchCongestionManagementText?: string;
  supplyResearchCongestionManagementText?: string;
  congestionManagementText?: string;
  mainAsset?: UnderlyingAssets;
  reportDates?: string;
};

/**
 * Map the asset data
 * @param assetType - The asset type
 * @param fields - The fields
 * @returns The asset data
 */
export const assetDataMapper = ({
  assetType,
  replaceText,
  fields,
}: {
  assetType?: AssetType | undefined;
  fields: FieldProps;
  replaceText: Record<string, string>;
}): AssetData | null => {
  const {
    attachmentText,
    attachmentTitle,
    availableCapacityHigherThanRequiredCapacityText,
    downloadReportButtonLabel,
    expressInterestButton,
    congestionManagementText,
    researchApplicableText,
    mainAsset,
    reportDates,
  } = fields;

  const assetData = getAssetDataByAssetType(assetType, fields);

  if (!assetData) return null;

  const data = {
    ...assetData,
    attachmentText,
    attachmentTitle,
    availableCapacityHigherThanRequiredCapacityText,
    downloadReportButtonLabel,
    congestionManagementText,
    researchApplicableText,
    reportDates,
  };

  const enrichedData = enrichObjectData(data, replaceText);

  return {
    ...enrichedData,
    expressInterestButton,
    mainAsset,
  };
};
